import * as React from 'react'

import { Select as AntSelect, SelectProps } from 'antd'
import { BaseOptionType } from 'antd/es/select'

import Label from '../Label'
import RedAsterisk from '../RedAsterisk'

type Item = {
  id: any
  name: any
  disabled?: boolean
}

type FieldProps = {
  label?: React.ReactNode
  labelStyles?: string
  showRequiredSign?: boolean
  items: Item[]
  className?: string
  value?: any
  defaultValue?: any
  size?: 'large' | 'small' | 'middle'
  placeholder?: string
  onChange?: (id: any) => void
  onSelect?: (id: any) => void
  filterOption?: boolean | ((inputValue: string, option: BaseOptionType) => boolean)
  disabled?: boolean
  status?: 'warning' | 'error'
}

const SimpleSelect: React.FC<FieldProps & SelectProps> = (props) => {
  return (
    <>
      {props.label && (
        <Label htmlFor={props.id} className={`${props.labelStyles} d-block no-select hand-on-hover`}>
          {props.showRequiredSign && <RedAsterisk className={'mr-4'} />}
          {props.label}
        </Label>
      )}
      <AntSelect
        {...props}
        options={props.items.map((x) => {
          return {
            label: x.name,
            value: x.id,
            disabled: x.disabled,
          }
        })}
        onChange={(value: any) => {
          props.onChange && props.onChange(value)
        }}
        onSelect={(value: any) => {
          props.onSelect && props.onSelect(value)
        }}
      />
    </>
  )
}
export default SimpleSelect
